<template>
  <UploadDragger :columnKey="columnKey" @update="getAllList" :toTipsTxt="otherPageData.title">
    <div class="files-wrapper custom_upload">
      <div
        :class="[
          'operation-wrapper',
          !columnList.length && !fileList.length ? 'operation-wrapper-nocontent' : '',
        ]"
      >
        <div class="top-line">
          <a-dropdown>
            <div
              id="upload_voice_btn"
              class="upload_voice_btn operation_btn"
              data-rlog="all_up_click"
            >
              上传
            </div>
            <template #overlay>
              <ul class="upload_dropdown">
                <li>
                  <UploadAudioAndIrc @update="getAllList" :columnKey="columnKey">
                    <div class="upload_btn" data-rlog="all_up_click_file">
                      <UploadToolTips />
                    </div>
                  </UploadAudioAndIrc>
                </li>
                <li>
                  <div class="upload_btn" style="opacity: 0.3">上传文件夹</div>
                </li>
              </ul>
            </template>
          </a-dropdown>
          <TestTopBtn
            v-if="isFolderDetail"
            @update="getAllList"
            :columnKey="columnKey"
            :articleKeys="articleKeys"
          />
          <CannotCreateColumnTips
            v-if="otherPageData.deep && +otherPageData.deep >= CanCreateColumn"
          />
          <EditFileModal
            v-else
            @submit="createColumn"
            title="新建文件夹"
            rlogKey="all_new_click"
            placeholder="请输入文件夹名称"
          >
            <template v-slot:editImg>
              <img class="type-icon" :src="require('./imgs/folder.png')" />
            </template>
            <div class="add_folder operation_btn" data-rlog="all_new_click">新建文件夹</div>
          </EditFileModal>
        </div>
        <SearchFile
          v-show="columnList.length || fileList.length"
          @searchFile="searchFile"
          rlogkey="all_search_click"
          :isSearchFile="isSearchFile"
          ref="searchFileRef"
        ></SearchFile>
        <div class="second-line">
          <div
            class="cancel-search"
            v-if="isSearchFile"
            @click="cancelSearch"
            data-rlog="all_search_click_back"
          >
            返回
          </div>
          <div
            class="breadcrumb_navigation"
            v-else-if="
              isFolderDetail || ((columnList.length || fileList.length) && !isFolderDetail)
            "
          >
            <!-- <div class="breadcrumb" v-if="!isFolderDetail">全部文件</div>
            <router-link class="breadcrumb folder-breadcrumb" to="/main" v-if="isFolderDetail"
              ><NavBar></NavBar
            ></router-link>
            <img class="detail-page" src="./imgs/breadcrumb-icon.png" v-if="isFolderDetail" /><span
              class="page-folder-title"
              >{{ otherPageData.title }}</span
            > -->
            <NavBar
              @setParentNavList="setParentNavList"
              :parentNavList="parentNavList"
              :title="title"
            ></NavBar>
            <div class="file_operation" v-show="checkedCount">
              <div class="choose_count">
                已选择<span class="num">{{ checkedCount }}</span
                >项
              </div>
              <UploadIrc
                @update="getAllList"
                accept=".lrc"
                :columnKey="columnKey"
                isAddIrc="isAddIrc"
                :checkFileList="checkFileList"
                ref="addIrcRef"
                ><div
                  class="add_lyrics"
                  v-if="showArrIrc"
                  checkFileList="checkFileList"
                  data-rlog="all_top_add"
                >
                  添加字幕
                </div></UploadIrc
              >
              <ConfirmModal @confirm="deleteSelected" rlogKey="all_top_delete"
                ><a class="delete_btn">删除</a></ConfirmModal
              >
            </div>
            <SortFile
              v-if="columnList.length || fileList.length"
              rlogKey="all"
              @sort="getAllList"
            ></SortFile>
            <a-tooltip
              v-if="columnList.length || fileList.length"
              placement="top"
              overlayClassName="my-tooltips"
              title="切换视图"
            >
              <div :class="['change-lyout', `change-lyout-${currentLayout}`]">
                <div @click="changeLayout" :class="['show-icon-grid']" />
                <div @click="changeLayout" :class="['show-icon-flow']" />
              </div>
            </a-tooltip>
          </div>
        </div>
      </div>

      <div ref="scrollRef" class="content">
        <empty
          title="鼠标拖拽也可以上传文件哦~"
          v-if="(!columnList.length &amp;&amp; !fileList.length &amp;&amp; !isSearchFile)"
        ></empty>
        <empty
          v-else-if="(!columnList.length &amp;&amp; !fileList.length &amp;&amp; isSearchFile)"
          :title="searchNoContentTip"
        ></empty>
        <div class="folder-title" v-if="columnList.length">我的文件夹</div>
        <MouseSeleted
          keyType="folder"
          :scrollRef="scrollRef"
          :class="['folder-wrapper', `folder-wrapper-${currentLayout}`]"
        >
          <div
            class="folder_list"
            :key="index"
            v-for="({ columnInfo, articleList }, index) in columnList"
          >
            <keep-alive>
              <folder
                :articleList="articleList"
                :currentLayout="currentLayout"
                :key="columnInfo.columnKey"
                :name="columnInfo.title"
                :dataSource="columnInfo"
                :columnKey="columnInfo.columnKey"
                :parentColumnKey="columnInfo.parentColumnKey"
                :checkFolderList="checkFolderList"
                :checkFileList="checkFileList"
                :checkIrcList="checkIrcList"
                :checked="getIsFolderChecked(columnInfo)"
                @initChoose="initChoose"
                @checkedFolderList="checkedFolderList"
                @update="fetchData"
                @setParentNavList="setParentNavList"
              ></folder>
            </keep-alive>
          </div>
        </MouseSeleted>
        <div class="file-title" v-if="fileList.length">
          我的文件
          <div
            class="choose-all-btn"
            :class="[
              checkFileList.length + checkIrcList.length === fileList.length ? 'checked' : '',
            ]"
          >
            <div
              @click="chooseAll"
              :class="[
                checkFileList.length + checkIrcList.length === fileList.length
                  ? 'check-box-checked'
                  : 'check-box-unckeck',
                'my-check-box',
              ]"
            ></div>
            <div class="txt">共 {{ checkFileList.length + checkIrcList.length }} 项</div>
          </div>
        </div>
        <MouseSeleted
          keyType="file"
          :scrollRef="scrollRef"
          :class="['file-wrapper', `folder-wrapper-${currentLayout}`]"
        >
          <div class="file_list" :key="index" v-for="(item, index) in fileList">
            <file
              :index="index"
              :currentLayout="currentLayout"
              :key="item.articleKey"
              :name="item.title"
              :columnKey="item.columnKey"
              :fileList="fileList"
              @updatefilePlayStatus="updatefilePlayStatus"
              :dataSource="item"
              @getAllList="getAllList"
              :checkFolderList="checkFolderList"
              :checkFileList="checkFileList"
              :checkIrcList="checkIrcList"
              :checked="getIsFileChecked(item)"
              @initChoose="initChoose"
              @checkedFileList="checkedFileList"
              @update="fetchData"
            ></file>
          </div>
        </MouseSeleted>
      </div>
      <HomeNewUserGuide />
    </div>
  </UploadDragger>
</template>

<script setup>
import { useStore } from 'vuex';
import { ref, computed, watch, reactive, onMounted, defineEmits, defineProps } from 'vue';
import { message } from 'ant-design-vue';
import businessService from '@/services/business';
import SortFile from '../../components/SortFile/index.vue';
import SearchFile from '../../components/SearchFile/index.vue';
import folder from './components/Folder/folder.vue';
import File from './components/file.vue';
import empty from '../../components/common/EmptyStatus.vue';
import UploadAudioAndIrc from '../../components/Upload/UploadAudioAndIrc.vue';
import UploadIrc from '../../components/Upload/UploadIrc.vue';
import UploadDragger from '../../components/Upload/UploadDragger.vue';
import MouseSeleted from '@/components/MouseSeleted/index.vue';
import NavBar from '@/components/NavBar/index.vue';
import routeController from '@/controller/router';
import EditFileModal from '../../components/common/EditFileModal.vue';
import {
  changeAddIrcStatus,
  deleteFolderBatch,
  getAllArticleAndTextFileList,
  CanCreateColumn,
} from './methods';
import ConfirmModal from '../../components/common/ConfirmModal.vue';
import HomeNewUserGuide from './components/HomeNewUserGuide/index.vue';
import UploadToolTips from './components/UploadToolTips.vue';
import CannotCreateColumnTips from './components/CannotCreateColumnTips.vue';
import services from '../../services';
import { batchDelete, urlResquest } from '../../services/urlConfig';
import { getIsLyric, getIsLyricShow } from '../../utils/utils';
import Store from '../../utils/localStorage';
import { defaultLayout, layoutConfig } from './homeConfig';
import TestTopBtn from './components/TestTopBtn/index.vue';
import './index.scss';

const props = defineProps({
  columnKey: String,
  isFolderDetail: Boolean,
});
const scrollRef = ref(null);
const columnList = ref([]); // 文件夹列表
const checkFolderList = ref([]); // 选中的文件夹列表 id
const checkFileList = ref([]); // 选中的文件列表 id
const checkIrcList = ref([]); // 选中的irc列表 id
const fileList = ref([]); // 默认文件夹的文件列表
const isSearchFile = ref(false); // 是否是搜索
const searchFileRef = ref(null);
const searchNoContentTip = ref(null);
const showArrIrc = ref(false); // 是否展示添加字幕
const addIrcRef = ref(null);
const otherPageData = ref({});
const store = useStore();
const title = ref(''); // 当前文件夹名称
const columnKey = ref(props.columnKey);
const { changePage } = routeController();
let userId = '';
const localStorageKey = `${userId}-home-layout`;
const currentLayout = ref(defaultLayout);

watch(
  () => store.state.userInfo,
  (newValue = {}) => {
    userId = newValue.userId;
    if (userId) {
      const lLyout = Store.get(localStorageKey);
      if (lLyout) {
        currentLayout.value = lLyout;
      }
    }
  },
  { immediate: true }
);
const parentNavList = computed(() => store.state.parentNavList);
let newList = [...parentNavList.value];
function setParentNavList(type, item, index) {
  if (type === 'slice') {
    changePage('/main/details', { key: item });
    newList = newList.slice(0, index);
    // console.log(newList);
  }
  if (type === 'push') {
    if (item !== '') {
      newList.push(item);
    }
  }
  if (type === 'init') {
    changePage('/main', { key: 'defaultColumnKey' });
    newList.length = 0;
    // store.commit('init');
  }
  store.commit('setParentNavList', newList);
}
function changeLayout() {
  currentLayout.value = layoutConfig[currentLayout.value].next;
  Store.set(localStorageKey, currentLayout.value);
  window._rlog.push(['_trackEvent', `all_change_layout_${currentLayout.value}`]);
}

const articleGetListByPage = (params = { sortKey: 'alphabeticIncrease' }) => {
  businessService
    .getArticleAndTextFileList(
      {
        ...params,
        columnKey: props.columnKey,
      },
      {},
      { loadingId: 'home', showLoading: true }
    )
    .then(res => {
      if (res.code === 0) {
        fileList.value = res.data.articleList || [];
        fileList.value = fileList.value.map((item, index) => {
          const data = {
            ...item,
            key: index,
            isEdit: false,
            tempFilename: '',
            subtitleList: [],
          };
          return data;
        });
        otherPageData.value = res.data.ColumnInfo || {};
        title.value = otherPageData.value.title;
        columnList.value = res.data.columnList.map(columnInfo => {
          return {
            columnInfo,
            articleList: [],
          };
        });
      } else {
        message.error({ content: res.msg });
      }
    })
    .catch(e => {
      message.error({ content: e });
    });
};
// 获取全部内容
let getAllList = (params = { sortKey: 'alphabeticIncrease' }) => {
  getAllArticleAndTextFileList(params, {}, { loadingId: 'home', showLoading: true }).then(res => {
    if (res.code === 0) {
      columnList.value = res.data.columnList || [];
      fileList.value = res.data.articleList.map((item, index) => {
        const data = {
          ...item,
          key: index,
          isEdit: false,
          tempFilename: '',
          subtitleList: [],
        };
        return data;
      });
    }
  });
};
if (props.isFolderDetail) {
  getAllList = articleGetListByPage;
}
watch(columnKey, newValue => {
  if (newValue) {
    const params = { sortKey: 'alphabeticIncrease', columnKey: newValue };
    getAllList(params);
  }
});
function searchFile(query, status) {
  isSearchFile.value = status;
  searchNoContentTip.value = `暂未搜索到“${query.query}”相关的文件或文件夹`;
  getAllList(query);
}
function changeIrcStatus() {
  if (changeAddIrcStatus(checkFolderList.value, checkFileList.value, checkIrcList.value)) {
    showArrIrc.value = true;
  } else {
    showArrIrc.value = false;
  }
}
const checkedCount = computed(
  () => checkFolderList.value.length + checkFileList.value.length + checkIrcList.value.length
);
const checkedFolderList = (params, status) => {
  // 选择文件夹
  if (status) {
    checkFolderList.value.push(params);
  } else {
    checkFolderList.value = checkFolderList.value.filter(item => item.id !== params.id);
  }
  changeIrcStatus(params);
};

const checkedFileList = (params, status) => {
  if (status) {
    // 选中
    if (getIsLyricShow(params.type)) {
      checkIrcList.value.push(params);
    } else {
      checkFileList.value.push(params);
    }
  } else if (getIsLyricShow(params.type)) {
    checkIrcList.value = checkIrcList.value.filter(item => item.id !== params.id);
  } else {
    checkFileList.value = checkFileList.value.filter(item => item.id !== params.id);
  }
  changeIrcStatus(params);
};
// 选择全部文件
function chooseAll() {
  const isChoose = checkFileList.value.length + checkIrcList.value.length === fileList.value.length;
  checkIrcList.value = [];
  checkFileList.value = [];
  if (isChoose) {
    // 取消全选
    window._rlog.push(['_trackEvent', 'all_check_click_cancel']);
    return;
  }
  window._rlog.push(['_trackEvent', 'all_check_click']);
  fileList.value.forEach(file => {
    if (getIsLyricShow(file.type)) {
      // if(chi)
    } else {
      // checkFileList.value.push(params)
    }
    checkedFileList({ key: file.articleKey, id: file.articleKey, type: file.type }, true);
  });
}
// 重命名、新建、修改专辑
const fetchData = (type, status, key) => {
  if (type === 'file') {
    // 删除选中的文件
    if (status === 'delete') {
      checkFileList.value = checkFileList.value.filter(item => item.id !== key);
    }
    // 删除选中的文件夹
  } else if (status === 'delete') {
    checkFolderList.value = checkFolderList.value.filter(item => item.id !== key);
  }
  getAllList();
};
let canClickCreateColumn = true; // 可以点击创建按钮
// 创建专辑
const createColumn = (value, callback) => {
  if (!canClickCreateColumn) {
    return;
  }
  const params = { title: value };
  if (props.columnKey) {
    params.parentColumnKey = props.columnKey;
  }
  canClickCreateColumn = false;
  urlResquest
    .createColumn(params, { loadingId: 'home', showLoading: true })
    .then(res => {
      canClickCreateColumn = true;
      if (res.code === 0) {
        fetchData('folder');
        callback(false);
      } else {
        message.error({ content: res.msg });
      }
    })
    .catch(e => {
      canClickCreateColumn = true;
      message.error({ content: e });
    });
};
function initChooseFile() {
  checkIrcList.value = [];
  checkFileList.value = [];
}
function initChoose() {
  checkFolderList.value = [];
  initChooseFile();
}
// 批量删除
const deleteSelected = toggleModal => {
  let deletePromises = [];
  let batchDeletePromise;
  if (checkIrcList.value.length > 0 || checkFileList.value.length > 0) {
    batchDeletePromise = new Promise(resolve => {
      services
        .post(batchDelete.url, {
          articleKeyList: JSON.stringify([...checkIrcList.value, ...checkFileList.value]),
          columnKey: props.columnKey || 'defaultColumnKey',
        })
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          resolve(e);
        });
    });
    deletePromises.push(batchDeletePromise);
  }
  const deleteFolderPromises = checkFolderList.value.map(item => deleteFolderBatch(item.id));

  deletePromises = [...deletePromises, ...deleteFolderPromises];
  const hideLoading = message.loading({ content: 'loading', duration: 0 });
  Promise.all(deletePromises)
    .then(() => {
      toggleModal(false);
      getAllList();
      initChoose();
      hideLoading();
      if (deleteFolderPromises.length > 0) {
        store.dispatch('getUserInfo');
      }
    })
    .catch(() => {
      message.error({ content: '网络出错，请重试' });
      hideLoading();
    });
};
watch(
  () => props.columnKey,
  newValue => {
    if (newValue) {
      getAllList();
    }
  }
);
onMounted(() => {
  getAllList();
});
const cancelSearch = () => {
  searchFileRef.value.cancelSearch();
  searchFile({}, false);
};
function updatefilePlayStatus(newValue) {
  fileList.value = newValue;
}

function getIsFileChecked(item) {
  if (getIsLyricShow(item.type)) {
    return checkIrcList.value.findIndex(itemData => itemData.id === item.articleKey) > -1;
  }
  return checkFileList.value.findIndex(itemData => itemData.id === item.articleKey) > -1;
}
function getIsFolderChecked(item) {
  return checkFolderList.value.findIndex(itemData => itemData.id === item.columnKey) > -1;
}
const articleKeys = reactive([]);
function getArticleKeys(data) {
  data.forEach(item => {
    if (!getIsLyric(item.title)) {
      articleKeys.push(item.articleKey);
    }
  });
}
watch(
  () => fileList.value,
  newValue => {
    getArticleKeys(newValue);
  },
  {
    immediate: true,
  }
);
</script>

<style lang="scss" scoped>
$padding: 40px;

.upload-file {
  display: inline-block;
}
.detail-page {
  width: 24px;
  height: 24px;
  margin: 0 10px;
}

.files-wrapper {
  height: 100vh;
  // position: absolute;
  // width: calc(100% - 260px);
  overflow: auto;
  .cancel-search {
    text-align: left;
    font-size: 19px;
    color: #3a89ff;
    cursor: pointer;
  }
  .breadcrumb_navigation {
    position: relative;
    display: flex;
    align-items: center;
    .file_operation {
      display: flex;
      align-items: center;
    }
    .add_lyrics {
      color: #3a89ff;
      font-size: 17px;
      margin-right: 30px;
      cursor: pointer;
    }
    .delete_btn {
      color: $red1;
      font-size: 17px;
    }
    .breadcrumb,
    .choose_count {
      font-weight: 500;
      color: $grey2;
      font-size: 17px;
    }
    .choose_count {
      margin-left: 30px;
      margin-right: 30px;
      font-weight: 500;
      .num {
        color: $red1;
      }
    }
  }
  .folder-title,
  .file-title {
    text-align: left;
    padding: 0 $padding;
    margin-top: 20px;
    margin-bottom: 10px;
    line-height: 28px;
    font-weight: bold;
    color: $grey1;
    font-size: 19px;
  }
  .file-title {
    margin-top: 30px;
    .choose-all-btn {
      cursor: pointer;
      font-size: 15px;
      white-space: nowrap;
      line-height: 26px;
      color: #212327;
      font-weight: normal;
      margin-top: 11px;
      display: flex;
      .my-check-box {
        margin-right: 3px;
      }
    }
  }

  .folder-wrapper,
  .file-wrapper {
    padding: 0 $padding;
    .file,
    .folder {
      margin-bottom: 10px;
    }
  }
  .file-wrapper {
    padding-bottom: 80px;
    min-height: 400px;
  }
}
.folder-wrapper-grid {
  @include grid(175px);
}
.upload_dropdown {
  background: #ffffff;
  border-radius: 8px;
  padding: 8px 0;
  box-shadow: 0px 16px 30px rgba(0, 0, 0, 0.08);
  li {
    height: 42px;
    width: 180px;
    cursor: pointer;
    padding-left: 20px;
    line-height: 42px;
    &:hover {
      background: $grey4;
    }
    .upload_btn {
      width: 180px;
      height: 42px;
      line-height: 42px;
    }
  }
}
.mark::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2;
}
.content {
  overflow: auto;
  box-sizing: border-box;
  position: relative;
  height: calc(100vh - 180px);
}

.page-folder-title {
  line-height: 37px;
  color: #898a8e;
  font-size: 17px;
}
.operation-wrapper-nocontent {
  border: none;
}

::v-deep(.folder-breadcrumb) {
  color: #3a89ff !important;
}
</style>
